package org.gymly.data

import io.ktor.client.HttpClient
import org.gymly.api.PortalSession
import org.gymly.api.createGymlyImageHttpClient

object AdminRepo {
    val session = PortalSession()
    private val repository = HttpAdminRepository(session)
    val api: AdminRepository = repository
    val httpClient: HttpClient get() = repository.client
    val imageHttpClient: HttpClient by lazy { createGymlyImageHttpClient(session) }
}
